import { z } from "zod";

// --- Liabilities ---
// Matches ApplicantLiabilities interface

export const liabilitiesSchema = z.object({
  currentMortgagePayment: z.number().min(0, "Current mortgage payment is required"),
  otherMortgages: z.string().default("0"),
  carLoans: z.string().default("0"),
  otherPersonalLoans: z.string().default("0"),
  creditCards: z.string().default("0"),
  storeCards: z.string().default("0"),
  storeCardsLenders: z.string().optional(),
  usedPayDayLender: z.boolean().default(false),
});
export type LiabilitiesFormData = z.infer<typeof liabilitiesSchema>;

// --- Assets & Income ---
// Matches ApplicantAssets interface (which includes income fields)

export const assetsSchema = z.object({
  residence: z.string().default("0"),
  otherProperty: z.string().default("0"),
  householdContents: z.string().default("0"),
  carBoatsBikesCaravans: z.string().default("0"),
  savingsOffsetAccountBalance: z.string().default("0"),
  otherAssets: z.string().default("0"),
  grossYearlyIncome: z.number().min(0, "Gross yearly income is required"),
  netMonthlyIncome: z.number().min(0, "Net monthly income is required"),
  rentalIncome: z.number().min(0).default(0),
  parentingAllowance: z.number().min(0).default(0),
  pensionIncome: z.number().min(0).default(0),
});
export type AssetsFormData = z.infer<typeof assetsSchema>;

// --- Banking details ---

export const bankingDetailsSchema = z.object({
  bankName: z.string().min(1, "Bank name is required"),
});
export type BankingDetailsFormData = z.infer<typeof bankingDetailsSchema>;

// --- Self declaration ---

export const selfDeclarationSchema = z.object({
  declarantName: z.string().min(1, "Name is required"),
  declarantAddress: z.string().min(1, "Address is required"),
  declaredIncome: z.number().min(0, "Declared income is required"),
  canMeetCommitment: z.boolean().refine((v) => v === true, "You must confirm you can meet the commitment"),
});
export type SelfDeclarationFormData = z.infer<typeof selfDeclarationSchema>;
